import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { AbsenceGeneralForm } from "@/forms/absence-general-form";

export function OrganizationSettingsAbsenceGeneral() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("general.general")}
			icon={icon("Settings2")}
			variant="plain"
		>
			<AbsenceGeneralForm />
		</ContentCard>
	);
}
